<mat-sidenav-container class="h-screen" autosize>
  <mat-sidenav mode="side" [opened]="true">
    <app-sidebar [(showSidebar)]="showSidebar"></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="h-full">
    @if (!showSidebar()) {
      <button
        mat-icon-button
        class="cursor-pointer hover:text-primary m-4 lg:!hidden !absolute left-0"
        (click)="showSidebar.set(true)">
        <mat-icon color="primary">menu</mat-icon>
      </button>
    }
    
    <main class="px-15 pb-15 overflow-auto overflow-x-hidden pt-16" [class.max-md:pt-20]="!showSidebar()">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
